import { forwardRef, createElement } from 'react';

function IconShowAll(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.25 6a1.75 1.75 0 011.744 1.606L21 7.75V11h-1.5V7.75l-.007-.057a.25.25 0 00-.175-.184L19.25 7.5H7.75l-.057.007a.25.25 0 00-.184.175L7.5 7.75v11.5l.007.057a.25.25 0 00.175.184l.068.009H11V21H7.75a1.75 1.75 0 01-1.744-1.606L6 19.25V7.75a1.75 1.75 0 011.606-1.744L7.75 6h11.5zm-2-3l.102.007a.75.75 0 010 1.486l-.102.007H4.75l-.057.007a.25.25 0 00-.184.175L4.5 4.75v12.5l-.007.102a.75.75 0 01-1.486 0L3 17.25V4.75l.006-.144a1.75 1.75 0 011.593-1.6L4.75 3h12.5zm-2.5 8.75a3 3 0 100 6 3 3 0 000-6zm0 7.5a4.5 4.5 0 113.632-1.842l.036-.05 2.362 2.362a.75.75 0 01-.976 1.133l-.084-.073-2.363-2.362-.112.077a4.479 4.479 0 01-2.495.755z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ShowAll = /*#__PURE__*/forwardRef(IconShowAll);

export default ShowAll;
//# sourceMappingURL=ShowAll.js.map
